module.exports = __webpack_public_path__ + "static/work_icon_launch-6ad8632391cd7fedab6e0020072f75cb.png";